<template>
  <div id="app">
    <header>
      <div id="logo">
        <img src="https://s3.amazonaws.com/assets.getready.com/Ready_logo_hrz_red_F1.png"
             style="height: 40px;" />
      </div>
      <div>
        <input type="search"
               v-model="query"
               id="search"
               placeholder="Search..."
               autocomplete="off" />
      </div>
    </header>

    <div>
      <ul>
        <li v-for="(form, index) in filtered"
            :key="index"
            :value="form.link">
          <a target="_FORM"
             :href="form.link">{{ form.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      selected: null,
      query: null,
      forms: [
        {
          title: "Patient Consent Form - All States",
          link: "https://getready.formstack.com/forms/patient_consent"
        },

        {
          title: "Against Medical Advice (AMA)",
          link: "https://getready.formstack.com/forms/against_medical_advice"
        },
        {
          title: "Advance Beneficiary Notice of Noncoverage (ABN)",
          link:
            "https://getready.formstack.com/forms/advance_beneficiary_notice_of_noncoverage"
        },
        {
          title: "Notice of Privacy Practices",
          link:
            "https://getready.formstack.com/forms/notice_of_privacy_practices"
        },
        {
          title: "Notice of Privacy Practices (CRISP)",
          link:
            "https://getready.formstack.com/forms/notice_of_privacy_practices_crisp"
        },
        {
          title: "Notice of Privacy Practices (Spanish)",
          link:
            "https://getready.formstack.com/forms/notice_of_privacy_practices_spanish"
        },
        {
          title: "Notice of Privacy Practices (Haitian Creole)",
          link:
            "https://getready.formstack.com/forms/notice_of_privacy_practices_haitian_creole"
        },
        {
          title: "Release of Medical Records",
          link:
            "https://getready.formstack.com/forms/general_authorization_for_use"
        },
        {
          title: "Flu Vaccines Contraindications",
          link:
            "https://getready.formstack.com/forms/flu_vaccines_contraindications"
        },
        {
          title: "Release of Psychotherapy Records",
          link:
            "https://getready.formstack.com/forms/psychotherapy_consent_form"
        },
        {
          title: "Release of Mental Health Records",
          link: "https://getready.formstack.com/forms/mental_health_consent"
        },
        {
          title: "Standing Order Patient Consent",
          link: "https://getready.formstack.com/forms/consent_for_covid_test"
        },
        {
          title: "Standing Order Patient Consent (Spanish)",
          link:
            "https://getready.formstack.com/forms/consent_for_covid_test_spanish"
        },
        {
          title: "Standing Order Patient Consent (Haitian Creole)",
          link:
            "https://getready.formstack.com/forms/consent_for_covid_test_haitian_creole"
        },
        {
          title: "Patient Consent Form - All States (Spanish)",
          link: "https://getready.formstack.com/forms/patient_consent_spanish"
        },
        {
          title: "Patient Consent Form - All States (Haitian Creole)",
          link:
            "https://getready.formstack.com/forms/patient_consent_haitian_creole"
        },
        {
          title: "CDC Covid Screen Questionnaire",
          link:
            "https://getready.formstack.com/forms/cdc_covid_screen_questionnaire"
        },
        {
          title: "Broward County Release of Information",
          link: "https://getready.formstack.com/forms/broward_county_release"
        },
        {
          title: "ROI - Jacobs Entertainment",
          link: "https://getready.formstack.com/forms/jacobs_entertainment_roi"
        },
        {
          title: "Patient Care Event Report Form",
          link:
            "https://getready.quickbase.com/db/bryuf7qjd?a=nwr"
        },
        {
          title: "COVID-19 Pre-Vaccination Screening Form",
          link:
            "https://getready.formstack.com/forms/covid19_prevaccination_screening_form"
        },
        {
          title: "EMS Activation Report Form",
          link:
            "https://getready.formstack.com/forms/911_activation_report_form"
        }
      ]
    };
  },
  computed: {
    filtered() {
      if (!this.query || this.query.length < 2) {
        return this.forms;
      } else {
        return this.forms.filter(
          form =>
            form.title.toLowerCase().indexOf(this.query.toLowerCase()) > -1
        );
      }
    }
  },
  watch: {
    selected() {
      this.$refs.forms.blur();
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap");
body {
  width: 100%;
  min-height: 100vh;
  margin: 0px;
  padding: 0px;
}
#app {
  font-family: "Source Sans Pro", sans-serif;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  font-weight: 300;
}
header {
  padding: 0;
  border-bottom: 1px solid #ddd;
  position: sticky;
  top: 0;
  background-color: #fff;
}
h1 {
  font-weight: 300;
  margin: 0px;
  padding: 0px;
}

ul {
  list-style-type: none;
  margin: 0px;
  padding: 0px;
}

li {
  padding: 0px;
  border-bottom: 1px solid #eee;
  margin: 0px;
  list-style-type: none;
}

li a,
a:visited {
  display: block;
  padding: 2rem 1rem;
  color: #000;
  text-decoration: none;
}

a:active {
  background-color: #f7f7f7;
}
#logo {
  padding: 1rem;
}
#search {
  border: none;
  outline: none;
  background-color: #fff;
  border-top: 1px solid #ddd;
  -webkit-appearance: none;
  font-family: "Source Sans Pro", sans-serif;
  display: block;
  padding: 1rem;
  font-size: 1rem;
  display: block;
  width: 100%;
}
</style>
